"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  design: {
    path: 'design',
    permissions: ['quest.design', 'quest.admin']
  },
  deploy: {
    path: 'deploy',
    permissions: ['quest.deploy', 'quest.admin']
  },
  status: {
    path: 'status',
    permissions: ['quest.status', 'quest.admin']
  },
  data: {
    path: 'data',
    permissions: ['quest.view_data', 'quest.admin']
  },
  code: {
    path: 'code',
    permissions: ['quest.code', 'quest.admin']
  },
  permissions: {
    path: 'permissions',
    permissions: ['quest.permissions']
  },
  manage: {
    path: 'projects',
    permissions: ['quest.admin']
  },
  usage: {
    path: 'usage',
    permissions: ['quest.admin']
  },
  guide: {
    path: 'guide',
    permissions: ['quest.code', 'quest.deploy', 'quest.design', 'quest.export', 'quest.permissions', 'quest.status', 'quest.view_data', 'quest.admin']
  }
};